import { useState, useCallback } from 'react';

/**
 * Hook for managing chat attachments
 * Handles attachment state and message attachment mapping
 */
export function useChatAttachments() {
  const [attachments, setAttachments] = useState<any[]>([]);
  const [messageAttachments, setMessageAttachments] = useState<Record<string, any[]>>({});

  const addAttachment = useCallback((attachment: any) => {
    setAttachments(prev => [...prev, attachment]);
  }, []);

  const removeAttachment = useCallback((attachmentId: string) => {
    setAttachments(prev => prev.filter(att => att.id !== attachmentId));
  }, []);

  const clearAttachments = useCallback(() => {
    setAttachments([]);
  }, []);

  const storeMessageAttachments = useCallback((messageId: string, attachments: any[]) => {
    setMessageAttachments(prev => ({
      ...prev,
      [messageId]: attachments
    }));
  }, []);

  return {
    attachments,
    setAttachments,
    messageAttachments,
    addAttachment,
    removeAttachment,
    clearAttachments,
    storeMessageAttachments,
  };
}

